import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormFeedback,
  FormGroup,
  Input,
} from "reactstrap";
import InputField from "../../Utils/InputField";
import SelectField from "../../Utils/SelectField";
import { LabelText } from "../../Utils/Input";
import {
  initialValues,
  SubscriptionEndsOnOptions,
  SubscriptionStartsOnOptions,
  TimePeriodEndOptions,
  timePeriodOption,
  timePeriodOptionStart,
} from "./constants/initialValues";
import { setEndsOnOption } from "./constants/displayInfinite";
import { handleEndDate, handleStartDate } from "./constants/initialValues";
import { ErrorMessage } from "formik";
import { useContext, useEffect } from "react";
import CommonDateTimePicker from "../../Utils/CommonDateTimePicker";
import moment from "moment";
import { CreatableSelectField } from "../../Utils/CreatableSelectField";
import {
  handleAggregateForOffer,
  handlePolicyForOffer,
} from "./constants/checkEmptyFields";
import { handleChangeForSubscriptionValidity } from "./constants/UpdateOfferJsonObj";
import { CreateOfferContext } from "./context";

export default function OfferDetails() {
  const {
    touched,
    setFormValues,
    isEdit,
    isSubscribed,
    errors,
    handleChange,
    handleBlur,
    values,
    setFieldTouched,
    setFieldValue,
    state,
    setState,
    TimePeriodOptions,
    startDate,
    setStartDate,
    handleStartDateChange,
    globalState,
    setGlobalState,
    addOnState,
    setAddOnState,
    serviceBarringState,
    setServiceBarringState,
    serviceData,
    policiesOptions,
    aggregateResourceOptions,
  } = useContext(CreateOfferContext);
  const rolename = localStorage.getItem("roleName");
  const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  return (
    <>
      <Row className="mb-4 gy-4">
        <Col xxl={3} lg={4} md={6}>
          <LabelText
            htmlFor={"offerName"}
            className={"text-danger"}
            displayText={"Offer Name"}
            important={"*"}
            classLabelName={isEdit ? "label-disable-color-edit-offer" : ""}
          />
          <LabelText
            htmlFor={"offerName"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.offerName && errors.offerName
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.offerName && errors.offerName
                ? errors.offerName
                : "Enter Offer Name"
            }
          />
          <InputField
            name={"offerName"}
            disabled={isEdit ? true : false}
            type={"text"}
            className={`form-control ${
              isEdit ? "label-disable-color-edit-offer" : ""
            }`}
            id={"offerName"}
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.offerName}
            invalid={touched.offerName && errors.offerName ? true : false}
          />
        </Col>
        <Col xxl={3} lg={4} md={6}>
          <LabelText
            htmlFor={"offerCode"}
            className={"text-danger"}
            displayText={"Offer Code"}
            important={"*"}
            classLabelName={isEdit ? "label-disable-color-edit-offer" : ""}
          />
          <LabelText
            htmlFor={"offerCode"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.offerCode && errors.offerCode
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.offerCode && errors.offerCode
                ? errors.offerCode
                : "Enter Offer Code"
            }
          />
          <InputField
            name={"offerCode"}
            disabled={isEdit ? true : false}
            type={"text"}
            className={`form-control ${
              isEdit ? "label-disable-color-edit-offer" : ""
            }`}
            id={"offerCode"}
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.offerCode}
            invalid={touched.offerCode && errors.offerCode ? true : false}
          />
        </Col>
        <Col xxl={3} lg={4} md={6}>
          <LabelText
            htmlFor={"offerStartsOn"}
            className={"text-danger"}
            displayText={"Starts on"}
            important={"*"}
          />
          <LabelText
            htmlFor={"offerStartsOn"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.offerStartsOn && errors.offerStartsOn
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.offerStartsOn && errors.offerStartsOn
                ? errors.offerStartsOn
                : dateFormat
            }
          />
          <CommonDateTimePicker
            className={`form-control ${
              touched.offerStartsOn && !values.offerStartsOn
                ? "error-input"
                : ""
            }`}
            views={["year", "month", "day"]}
            value={values.offerStartsOn}
            placeholder={" "}
            name={`offerStartsOn`}
            format={dateFormat}
            style={{
              height: "38px",
              fontSize: "0.875rem",
              borderRadius: "0.5rem",
            }}
            handleChange={(value) => {
              setFieldValue("offerStartsOn", value);
              //future use
              // handleStartDate(handleStartDateChange, setStartDate, setFieldTouched, setFieldValue)
            }}
          />
        </Col>
        <Col xxl={3} lg={4} md={6}>
          {!state ? (
            <div>
              <LabelText
                htmlFor={"offerEndsOn"}
                className={"text-danger"}
                displayText={"Ends on"}
                important={"*"}
              />
              <LabelText
                htmlFor={"offerEndsOn"}
                classLabelName={`d-block ms-0 rv-sub-label ${
                  touched.offerEndsOn && errors.offerEndsOn
                    ? "rv-label-danger"
                    : "rv-label-muted"
                } `}
                displayText={
                  touched.offerEndsOn && errors.offerEndsOn
                    ? errors.offerEndsOn
                    : dateFormat
                }
              />
              <CommonDateTimePicker
                className={`form-control ${
                  touched.offerEndsOn && !values.offerEndsOn
                    ? "error-input"
                    : ""
                }`}
                value={values.offerEndsOn}
                name={`offerEndsOn`}
                format={dateFormat}
                placeholder={" "}
                style={{
                  height: "38px",
                  fontSize: "0.875rem",
                  borderRadius: "0.5rem",
                }}
                views={["year", "month", "day"]}
                minDate={values.offerStartsOn}
                handleChange={handleEndDate(setFieldTouched, setFieldValue)}
              />
            </div>
          ) : null}
        </Col>

        <Col xxl={3} lg={4} md={6}>
          <LabelText htmlFor={"categories"} displayText={"Categories"} />
          <LabelText
            htmlFor={"categories"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.categories && errors.categories
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.categories && errors.categories
                ? errors.categories
                : "Enter Your Categories"
            }
          />
          <CreatableSelectField
            className={
              (errors.categories && touched.categories) || false
                ? "error-input"
                : ""
            }
            values={values.categories}
            placeholder={" "}
            handleChange={(value) => {
              setFieldValue(`categories`, value, false);
              setFieldTouched(`categories`, false);
            }}
            onKeyDown={(event) => {
              const key = event.key;
              const regex = /^[a-zA-Z0-9\s_]$/;
              if (
                regex.test(key) ||
                [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Enter",
                ].includes(key)
              ) {
                return;
              }
              event.preventDefault();
            }}
            isMulti={true}
            name={"categories"}
            fieldName={"categories"}
            setFieldValue={setFieldValue}
            //   errors={errors.categories}
            isClearable={true}
            handleBlur={handleBlur}
            touched={touched.categories}
            isRVStyle={true}
          />
        </Col>
        <Col xxl={3} lg={4} md={6}>
          <LabelText htmlFor={"offerPriority"} displayText={"Priority"} />{" "}
          <LabelText
            htmlFor={"offerPriority"}
            classLabelName={`numeric-code d-block ms-0 rv-sub-label ${
              touched.offerPriority && errors.offerPriority
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.offerPriority && errors.offerPriority
                ? errors.offerPriority
                : "Enter Priority"
            }
          />
          <InputField
            name={"offerPriority"}
            disabled={isSubscribed ? true : false}
            type={"number"}
            className={`form-control ${
              isSubscribed ? "label-disable-color-edit-offer" : ""
            }`}
            id={"offerPriority"}
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.offerPriority}
          />
        </Col>
        {rolename === "telcoAdmin" ? (
          <Col xxl={3} lg={4} md={6}>
            <LabelText
              htmlFor={"policyName"}
              displayText={"Policy Specification"}
            />{" "}
            <LabelText
              htmlFor={"policyName"}
              classLabelName={`d-block ms-0 rv-sub-label ${
                touched.policyName && errors.policyName
                  ? "rv-label-danger"
                  : "rv-label-muted"
              } `}
              displayText={
                touched.policyName && errors.policyName
                  ? errors.policyName
                  : "Select a Policy"
              }
            />
            <SelectField
              className={
                errors.policyName && touched.policyName ? "error-input" : "mb-4"
              }
              placeholder={" "}
              name={`policyName`}
              labelName={"policyName"}
              value={values.policyName}
              isDisabled={isSubscribed || globalState ? true : false}
              isClearable
              handleChange={handlePolicyForOffer(values, setFieldValue)}
              options={policiesOptions}
              isRVStyle={true}
            />
          </Col>
        ) : null}
        <Col xxl={3} lg={4} md={6}>
          <LabelText
            htmlFor={"aggregateVolume"}
            displayText={"Aggregate Resources"}
          />{" "}
          <LabelText
            htmlFor={"aggregateVolume"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.aggregateVolume && errors.aggregateVolume
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.aggregateVolume && errors.aggregateVolume
                ? errors.aggregateVolume
                : "Select Aggregate Resources"
            }
          />
          <SelectField
            className={
              errors.aggregateVolume && touched.aggregateVolume
                ? "error-input"
                : "mb-3"
            }
            placeholder={" "}
            name={`aggregateVolume`}
            labelName={"aggregateVolume"}
            value={values.aggregateVolume}
            // isDisabled={(isSubscribed || globalState) ? true : false}
            isClearable
            isMulti
            handleChange={handleAggregateForOffer(values, setFieldValue)}
            options={aggregateResourceOptions}
            isRVStyle={true}
          />
        </Col>

        <Col xxl={12} md={12} className="mt-0">
          <LabelText
            htmlFor={"description"}
            className={"text-danger"}
            displayText={"Description"}
          />
          <LabelText
            htmlFor={"description"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.description && errors.description
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
            displayText={
              touched.description && errors.description
                ? errors.description
                : "Write a description of the offer"
            }
          />
          <InputField
            name={"description"}
            style={{ height: "100px" }}
            type={"textarea"}
            className={`form-control`}
            id={"description"}
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.description}
          />
        </Col>

        <Row className="pt-4">
          <Col xxl={3} lg={4} md={6}>
            <LabelText
              htmlFor={"subscriptionStartsOn"}
              className={"text-danger"}
              displayText={"Subscription Starts On"}
              important={"*"}
              classLabelName={
                isSubscribed ? "label-disable-color-edit-offer" : ""
              }
            />
            <LabelText
              htmlFor={"subscriptionStartsOn"}
              classLabelName={`d-block ms-0 rv-sub-label ${
                touched.subscriptionStartsOn && errors.subscriptionStartsOn
                  ? "rv-label-danger"
                  : "rv-label-muted"
              } `}
              displayText={
                touched.subscriptionStartsOn && errors.subscriptionStartsOn
                  ? errors.subscriptionStartsOn
                  : "Select a value"
              }
            />
            <SelectField
              isDisabled={isSubscribed ? true : false}
              className={
                (errors.subscriptionStartsOn && touched.subscriptionStartsOn) ||
                false
                  ? "error-input"
                  : ""
              }
              placeholder={" "}
              value={values.subscriptionStartsOn}
              handleChange={handleChangeForSubscriptionValidity(
                initialValues,
                setFieldValue,
                "Start"
              )}
              options={[...SubscriptionStartsOnOptions]}
              isRVStyle={true}
            />
          </Col>
          {values?.subscriptionStartsOn?.label === "Relative" && (
            <>
              <Col xxl={3} lg={3} md={6}>
                <LabelText
                  htmlFor={"timePeriodStart"}
                  className={"text-danger"}
                  displayText={"Time Period"}
                  classLabelName={
                    isSubscribed ? "label-disable-color-edit-offer" : ""
                  }
                />
                <InputField
                  name={"timePeriodStart"}
                  disabled={isSubscribed ? true : false}
                  type={"number"}
                  className={`form-control ${
                    isSubscribed ? "label-disable-color-edit-offer" : ""
                  }`}
                  id={"timePeriodStart"}
                  handleChange={handleChange}
                  value={values.timePeriodStart}
                />
              </Col>
              <Col xxl={3} md={6} className="period-option pe-0">
                <div data-testid="select-component">
                  <SelectField
                    name={`timePeriodOptionStart`}
                    isDisabled={isSubscribed ? true : false}
                    value={values.timePeriodOptionStart || ""}
                    handleChange={timePeriodOptionStart(values, setFieldValue)}
                    options={TimePeriodOptions}
                    isRVStyle={true}
                  />
                </div>
              </Col>
            </>
          )}

          <Col xxl={3} lg={4} md={6}>
            <LabelText
              htmlFor={"subscriptionEndsOn"}
              className={"text-danger"}
              displayText={"Subscription Ends On"}
              important={"*"}
              classLabelName={
                isSubscribed ? "label-disable-color-edit-offer" : ""
              }
            />
            <LabelText
              htmlFor={"subscriptionEndsOn"}
              classLabelName={`d-block ms-0 rv-sub-label ${
                touched.subscriptionEndsOn && errors.subscriptionEndsOn
                  ? "rv-label-danger"
                  : "rv-label-muted"
              } `}
              displayText={
                touched.subscriptionEndsOn && errors.subscriptionEndsOn
                  ? errors.subscriptionEndsOn
                  : "Select a value"
              }
            />
            <SelectField
              className={
                (errors.subscriptionEndsOn && touched.subscriptionEndsOn) ||
                false
                  ? "error-input"
                  : ""
              }
              placeholder={" "}
              value={values.subscriptionEndsOn}
              handleChange={handleChangeForSubscriptionValidity(
                initialValues,
                setFieldValue,
                "End"
              )}
              isDisabled={isSubscribed ? true : false}
              options={[...SubscriptionEndsOnOptions]}
              isRVStyle={true}
            />
          </Col>
          {values?.subscriptionEndsOn?.label === "Relative" && (
            <>
              <Col xxl={3} lg={3} md={6}>
                <LabelText
                  htmlFor={"timePeriod"}
                  className={"text-danger"}
                  displayText={"Time Period"}
                  classLabelName={
                    isSubscribed ? "label-disable-color-edit-offer" : ""
                  }
                />
                <LabelText
                  htmlFor={"timePeriod"}
                  classLabelName={`d-block ms-0 rv-sub-label ${
                    touched.timePeriod && errors.timePeriod
                      ? "rv-label-danger"
                      : "rv-label-muted"
                  } `}
                  displayText={
                    touched.timePeriod && errors.timePeriod
                      ? errors.timePeriod
                      : "Enter Time Period"
                  }
                />
                <InputField
                  name={"timePeriod"}
                  disabled={isSubscribed ? true : false}
                  type={"number"}
                  className={`form-control ${
                    isSubscribed ? "label-disable-color-edit-offer" : ""
                  }`}
                  id={"timePeriod"}
                  handleChange={handleChange}
                  value={values.timePeriod}
                />
              </Col>
              <Col xxl={3} lg={3} md={6} className="period-option pe-0">
                <div data-testid="select-component">
                  <LabelText
                    htmlFor={"timePeriodOption"}
                    className={"text-danger"}
                    displayText={""}
                    classLabelName={
                      isSubscribed ? "label-disable-color-edit-offer" : ""
                    }
                  />
                  <LabelText
                    htmlFor={"timePeriodOption"}
                    classLabelName={`d-block ms-0 rv-sub-label ${
                      touched.timePeriod && errors.timePeriod
                        ? "rv-label-danger"
                        : "rv-label-muted"
                    } `}
                    displayText={"Select Time Period"}
                  />
                  <SelectField
                    name={`timePeriodOption`}
                    isDisabled={isSubscribed ? true : false}
                    value={values.timePeriodOption || ""}
                    handleChange={timePeriodOption(values, setFieldValue)}
                    options={TimePeriodEndOptions}
                    isRVStyle={true}
                  />
                </div>
              </Col>
            </>
          )}
        </Row>
        <Row>
          {!isEdit ? (
            <Col className="mt-4 pe-0" xxl={3} lg={4} md={6}>
              <LabelText
                htmlFor={"addon"}
                className={"text-danger"}
                displayText={"Add On"}
                check
              />
              <LabelText
                htmlFor={"addon"}
                classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                displayText={"To Enable / Disable Add On offers"}
              />
              <FormGroup switch>
                <div className="flex-column justify-content-center align-items-center">
                  <Input
                    type={"switch"}
                    className="rv-form-switch-input"
                    checked={addOnState}
                    onClick={() => setAddOnState(!addOnState)}
                  />
                </div>
              </FormGroup>
            </Col>
          ) : null}

          <Col className="mt-4 pe-0" xxl={3} lg={4} md={6}>
            <LabelText
              htmlFor={"offerExpire"}
              className={"text-danger"}
              displayText={"Offer Never Expires"}
              check
            />
            <LabelText
              htmlFor={"offerExpire"}
              classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
              displayText={"To Enable / Disable Offer Expires"}
            />
            <FormGroup switch>
              <div className="flex-column justify-content-center align-items-center">
                <Input
                  type={"switch"}
                  className="rv-form-switch-input"
                  checked={state}
                  onClick={() => {
                    setState(!state);
                  }}
                />
              </div>
            </FormGroup>
          </Col>

          {!isEdit && !addOnState ? (
            <Col className="mt-4 pe-0" xxl={3} lg={4} md={6}>
              <LabelText
                htmlFor={"globalOffer"}
                className={"text-danger"}
                displayText={"Global Offer"}
                check
              />
              <LabelText
                htmlFor={"globalOffer"}
                classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
                displayText={"To Enable / Disable Global Offer"}
              />
              <FormGroup switch>
                <div className="flex-column justify-content-center align-items-center">
                  <Input
                    type={"switch"}
                    className="rv-form-switch-input"
                    checked={globalState}
                    onClick={() => setGlobalState(!globalState)}
                  />
                </div>
              </FormGroup>
            </Col>
          ) : null}

          <Col className="mt-4 pe-0" xxl={3} lg={4} md={6}>
            <LabelText
              htmlFor={"serviceBarring"}
              className={"text-danger"}
              displayText={"Service Barring"}
              check
            />
            <LabelText
              htmlFor={"serviceBarring"}
              classLabelName={`d-block ms-0 rv-sub-label rv-label-muted`}
              displayText={"To Enable / Disable Service Barring"}
            />
            <FormGroup switch>
              <div className="flex-column justify-content-center align-items-center">
                <Input
                  type={"switch"}
                  className="rv-form-switch-input"
                  checked={serviceBarringState}
                  onClick={() => {
                    setServiceBarringState(!serviceBarringState);
                  }}
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
      </Row>
    </>
  );
}
